export default "__VITE_ASSET__5a17b8e3__"